<div class="survey-info-step-content">
  <div class="survey-info-step-title">{{ getLangValue(stepData?.title) }}</div>
  <div class="survey-info-step-description" [innerHTML]="getLangValue(stepData?.description)"></div>
  <div class="survey-options-row">
    <div *ngFor="let option of pagedOptions" class="survey-option" [class.selected]="selectedOptionIds.includes(option._id)">
      <button type="button"
              (click)="onToggleOption(option)"
              [class.selected]="selectedOptionIds.includes(option._id)">
        <span>
          {{ getLangValue(option.text) }}
          <ng-container *ngIf="option.inputType === 'text'">
            <span class="specify-label"> ({{ getLangValue(option.description) }})</span>
          </ng-container>
        </span>
        <ng-container *ngIf="selectedOptionIds.includes(option._id) && option.inputType === 'text'">
          <input type="text" [(ngModel)]="textValues[option._id]" [placeholder]="getLangValue(option.description)" (click)="$event.stopPropagation()" />
          <div *ngIf="textValues[option._id] && textValues[option._id].trim().length > 0 && textValues[option._id].trim().length < 3" class="select-hint">
            {{ translate.instant('Please enter at least 3 characters') }}
          </div>
        </ng-container>
      </button>
    </div>
  </div>
  <button *ngIf="!allOptionsShown" type="button" (click)="onSeeMore()" class="c4g-raised-button show-more-btn">{{ translate.instant('buttons.more') }}</button>
  <div *ngIf="allOptionsShown && selectedOptionIds.length === 0" class="select-hint">{{ translate.instant('Please select at least one option') }}</div>
</div>
